import { Alert, Stack } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { useAppSelector } from '~/redux/hooks'
import { type Environment } from '~/utils/types/user'

const PROD_ENV: Environment = 'platform'

const NoProdWarningAlert = () => {
  const { t } = useTranslation()
  const [visible, setVisible] = useState(false)

  const env = useAppSelector(state => {
    if (!state.user) throw new Error('No user')
    return state.user.env
  })

  useEffect(() => {
    if (env !== undefined && env !== PROD_ENV) {
      setVisible(true)
    }
  }, [env])

  return (
    <>
      {visible && (
        <Stack sx={{ padding: '1rem' }}>
          <Alert
            onClose={() => {
              setVisible(false)
            }}
            severity="warning"
          >
            {t('views.nonProdWarning.warning')}
          </Alert>
        </Stack>
      )}
    </>
  )
}

export default NoProdWarningAlert
